import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { fetchAccountMe, fetchSbpBanks, patchAccountMe } from "../api/client.js";
import { useLayoutTitle } from "../context/LayoutTitleContext.jsx";
import {
  cacheGlobalProfileFromAccountMe,
  isVitrineLoggedIn,
} from "../lib/wicoopProfileStorage.js";
import styles from "./ProfilePage.module.css";

export default function SettingsPage() {
  const { setPageTitle } = useLayoutTitle();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [sbpBankId, setSbpBankId] = useState("");
  const [banks, setBanks] = useState([]);
  const [jumpEnabled, setJumpEnabled] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    setPageTitle("Настройки");
    return () => setPageTitle(null);
  }, [setPageTitle]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const [me, sbp] = await Promise.all([fetchAccountMe(), fetchSbpBanks()]);
        if (cancelled) return;
        setFirstName(me.first_name || "");
        setLastName(me.last_name || "");
        setSbpBankId(me.sbp_bank_id != null ? String(me.sbp_bank_id) : "");
        setJumpEnabled(!!sbp.jump_enabled);
        setBanks(Array.isArray(sbp.items) ? sbp.items : []);
      } catch (e) {
        if (!cancelled) setError(e.message || "Не удалось загрузить профиль");
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (!isVitrineLoggedIn()) {
    return <Navigate to="/profile/login" replace />;
  }

  async function handleSave(e) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    setSaved(false);
    try {
      const payload = {
        first_name: firstName.trim(),
        last_name: lastName.trim(),
      };
      if (jumpEnabled && sbpBankId) payload.sbp_bank_id = Number(sbpBankId);
      const me = await patchAccountMe(payload);
      cacheGlobalProfileFromAccountMe(me);
      setSaved(true);
    } catch (err) {
      setError(err.message || "Ошибка сохранения");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className={`${styles.page} ${styles.pageProfile}`}>
      <form className={styles.settingsForm} onSubmit={handleSave}>
        <div className={styles.field}>
          <label htmlFor="settings-first">Имя</label>
          <input
            id="settings-first"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            autoComplete="given-name"
          />
        </div>
        <div className={styles.field}>
          <label htmlFor="settings-last">Фамилия</label>
          <input
            id="settings-last"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            autoComplete="family-name"
          />
        </div>
        {jumpEnabled ? (
          <div className={styles.field}>
            <label htmlFor="settings-bank">Банк для СБП</label>
            <select
              id="settings-bank"
              value={sbpBankId}
              onChange={(e) => setSbpBankId(e.target.value)}
            >
              <option value="">Выберите банк</option>
              {banks.map((b) => (
                <option key={b.value} value={String(b.value)}>
                  {b.title}
                </option>
              ))}
            </select>
          </div>
        ) : null}
        {error ? <p className={styles.error}>{error}</p> : null}
        {saved ? <p className={styles.status}>Сохранено</p> : null}
        <button type="submit" className={styles.saveBtn} disabled={busy}>
          {busy ? "Сохранение…" : "Сохранить"}
        </button>
      </form>
    </div>
  );
}
